import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white letter-spacing lead-info-box rounded-0" }
const _hoisted_2 = { class: "card-head box-shadow bg-white p-15 p-sm-20 p-md-25 gap-3 d-flex justify-content-between flex-wrap" }
const _hoisted_3 = { class: "d-sm-flex align-items-center justify-content-between" }
const _hoisted_4 = { class: "fw-medium text-black-emphasis mb-0" }
const _hoisted_5 = {
  key: 1,
  class: "d-inline-flex flex-wrap gap-3 justify-content-end ms-auto"
}
const _hoisted_6 = ["onClick"]
const _hoisted_7 = /*#__PURE__*/_createElementVNode("i", { class: "ph-bold ph-plus position-relative ms-5 fs-12" }, null, -1 /* HOISTED */)
const _hoisted_8 = { class: "card-body p-15 p-sm-20 p-md-25" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SpinnerLoading = _resolveComponent("SpinnerLoading")!
  const _component_CenterHCPList = _resolveComponent("CenterHCPList")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h5", _hoisted_4, _toDisplayString(_ctx.$t('feature.roles.center_users_management')), 1 /* TEXT */)
      ]),
      (_ctx.roles === undefined || _ctx.permissions === undefined)
        ? (_openBlock(), _createBlock(_component_SpinnerLoading, { key: 0 }))
        : (_openBlock(), _createElementBlock("div", _hoisted_5, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.activeRoles, (role) => {
              return (_openBlock(), _createElementBlock("button", {
                key: role.id,
                onClick: ($event: any) => (_ctx.createUser(role)),
                class: "default-btn position-relative transition border-0 fw-medium text-white pt-11 pb-11 ps-25 pe-25 pt-md-12 pb-md-12 ps-md-30 pe-md-30 rounded-1 bg-success fs-md-15 fs-lg-16 d-inline-block text-decoration-none"
              }, [
                _createTextVNode(_toDisplayString(_ctx.$t('cta.create')) + " " + _toDisplayString(role.name) + " ", 1 /* TEXT */),
                _hoisted_7
              ], 8 /* PROPS */, _hoisted_6))
            }), 128 /* KEYED_FRAGMENT */))
          ]))
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createVNode(_component_CenterHCPList, {
        center_id: _ctx.id,
        onDelete: _ctx.update
      }, null, 8 /* PROPS */, ["center_id", "onDelete"])
    ])
  ]))
}